<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-filter</v-icon>
                Salary Process Filter
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="handleFilterSubmit">
                  <v-row class="py-2" dense>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="filters.process_scope"
                        :items="processScopeOptions"
                        item-title="label"
                        item-value="value"
                        label="Process Scope"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filters.year"
                        :items="yearOptions"
                        label="Year"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filters.month"
                        :items="months"
                        item-title="label"
                        item-value="value"
                        label="Month"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="filters.department_id"
                        :items="departments"
                        :item-title="(item) => item.name || item.department_name || ''"
                        item-value="id"
                        label="Department"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                        :loading="departmentsLoading"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-date-input
                        v-model="filters.from_date"
                        label="From Date"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        clearable
                        :max="filters.to_date"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-date-input
                        v-model="filters.to_date"
                        label="To Date"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        clearable
                        :min="filters.from_date"
                      />
                    </v-col>
                    <v-col cols="12" md="8" class="d-flex align-end ga-2">
                      <v-btn
                        type="submit"
                        color="primary"
                        :loading="listLoading"
                        prepend-icon="mdi-magnify"
                      >
                        Apply Filters
                      </v-btn>
                      <v-btn
                        variant="tonal"
                        prepend-icon="mdi-filter-remove"
                        @click="resetFilters"
                        :disabled="!hasActiveFilters"
                      >
                        Reset
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <v-expansion-panels v-model="listPanel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-format-list-bulleted</v-icon>
                Salary Process List
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
            <v-col md="4" cols="12">
              <v-text-field
                v-model="search"
                append-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                density="compact"
                variant="outlined"
                bg-color="grey-lighten-4"
                class="pl-2"
                clearable
              />
            </v-col>

            <v-col md="5" cols="12">
              <div class="d-flex align-center flex-column">
                <v-btn-group
                  variant="outlined"
                  density="compact"
                  size="x-small"
                  divided
                >
                  <v-btn
                    prepend-icon="mdi-download"
                    variant="flat"
                    color="success"
                    @click="exportToCSV"
                  >
                    CSV
                  </v-btn>
                  <v-btn
                    prepend-icon="mdi-download"
                    variant="flat"
                    color="primary"
                    @click="exportToExcel"
                  >
                    EXCEL
                  </v-btn>
                  <v-btn
                    prepend-icon="mdi-download"
                    variant="flat"
                    color="red"
                    @click="exportToPDF"
                  >
                    PDF
                  </v-btn>
                </v-btn-group>
              </div>
            </v-col>

            <v-col md="3" cols="12">
              <div class="text-right">
                <v-btn
                  @click="router.push({ name: 'run-salary-process' })"
                  color="primary"
                  variant="tonal"
                  prepend-icon="mdi-plus"
                  rounded="xl"
                >
                  Run Salary Process
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-data-table
                  :headers="tableHeaders"
                  :items="salaryProcesses"
                  :loading="listLoading"
                  :search="search"
                  class="mt-4"
                  density="compact"
                  hover
                  :items-per-page="itemsPerPage"
                  v-model:items-per-page="itemsPerPage"
                >
                  <template #item.index="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template #loading>
                    <div class="py-6 text-center text-medium-emphasis">
                      Loading salary processes...
                    </div>
                  </template>
                  <template #item.code="{ item }">
                    <span class="font-weight-medium">{{ item.code }}</span>
                  </template>
                  <template #item.process_scope="{ item }">
                    <v-chip
                      :color="getScopeColor(item.process_scope)"
                      size="small"
                      label
                    >
                      {{ formatScopeLabel(item.process_scope) }}
                    </v-chip>
                  </template>
                  <template #item.department="{ item }">
                    {{ item.department?.name || '—' }}
                  </template>
                  <template #item.employee="{ item }">
                    {{ item.employee?.name || '—' }}
                  </template>
                  <template #item.process_date="{ item }">
                    {{ formatDate(item.process_date) }}
                  </template>
                  <template #item.finalize_date="{ item }">
                    {{ formatDate(item.finalize_date) }}
                  </template>
                  <template #item.salary_status="{ item }">
                    <v-chip
                      :color="getStatusColor(item.salary_status)"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ formatStatusLabel(item.salary_status) }}
                    </v-chip>
                  </template>
                  <template #item.total_gross_salary="{ item }">
                    {{ item.total_gross_salary || '—' }}
                  </template>
                  <template #item.total_net_salary="{ item }">
                    {{ item.total_net_salary || '—' }}
                  </template>
                  <template #item.total_allowance="{ item }">
                    {{ item.total_allowance || '—' }}
                  </template>
                  <template #item.total_deduction="{ item }">
                    {{ item.total_deduction || '—' }}
                  </template>
                  <template #item.total_payable="{ item }">
                    {{ item.total_payable || '—' }}
                  </template>
                  <template #item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="primary"
                      @click="viewDetails(item.id)"
                    />
                  </template>

                  <template v-slot:item.approval_status_display="{ item }">
                    <v-chip
                      v-if="item?.approval_current_process?.status.toLowerCase() == 'pending'"
                      color="yellow-darken-3"
                      size="small"
                    >
                      Wating for {{ item?.approval_current_process?.approval_step_name?.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item?.approval_current_process?.status.toLowerCase() == 'approved'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item?.approval_current_process?.approval_step_name?.name }}
                    </v-chip>

                    <v-chip
                      v-else-if="item?.approval_current_process?.status.toLowerCase() == 'cancel'"
                      color="green"
                      size="small"
                    >
                      Approved By {{ item?.approval_current_process?.approval_step_name?.name }}
                    </v-chip>
                    <v-chip
                      v-else-if="item?.approval_current_process?.status.toLowerCase() == 'approved'"
                      color="red"
                      size="small"
                    >
                      Cancelled By  {{ item?.approval_current_process?.approval_step_name?.name }}
                    </v-chip>
                    <v-chip
                      v-else
                      color="green"
                      size="small"
                    >
                      {{ item?.approval_status }}
                    </v-chip>
                  </template>

                  <template #no-data>
                    <div class="py-6 text-center text-medium-emphasis">
                      No salary process records found. Try adjusting filters or run a new process.
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

  </v-app>
</template>

<script setup>
import { ref, reactive, onMounted, computed, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'
import formatDateView from '@/plugins/dateFormatView'

const router = useRouter()
const store = useStore()
const instance = getCurrentInstance()
const panel = ref([0])
const listPanel = ref([0])
const departmentsLoading = ref(false)
const listLoading = ref(false)
const itemsPerPage = ref(10)
const search = ref('')

// Options
const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 }
]

// Generate year options (from 2020 to current year + 5)
const currentYear = new Date().getFullYear()
const yearOptions = computed(() => {
  const years = []
  for (let year = 2020; year <= currentYear + 5; year++) {
    years.push(year)
  }
  return years.reverse() // Show most recent years first
})

const processScopeOptions = [
  { label: 'All', value: 'all' },
  { label: 'By Department', value: 'department' },
  { label: 'By Employee', value: 'employee' }
]

// Data
const departments = ref([])
const salaryProcesses = ref([])
const filters = reactive({
  process_scope: null,
  year: null,
  month: null,
  department_id: null,
  from_date: null,
  to_date: null
})

const tableHeaders = [
  { title: '#SL', key: 'index', sortable: false, width: '60px', align: 'center' },
  { title: 'Code', key: 'code', sortable: false, width: '120px' },
  { title: 'Process Scope', key: 'process_scope', sortable: false, width: '130px' },
  { title: 'Department', key: 'department', sortable: false },
  { title: 'Employee', key: 'employee', sortable: false },
  { title: 'Process Date', key: 'process_date', sortable: false },
  { title: 'Finalize Date', key: 'finalize_date', sortable: false },
  { title: 'Status', key: 'salary_status', sortable: false, align: 'center', width: '120px' },
  { title: 'Gross Salary', key: 'total_gross_salary', sortable: false, align: 'end' },
  { title: 'Net Salary', key: 'total_net_salary', sortable: false, align: 'end' },
  { title: 'Total Allowance', key: 'total_allowance', sortable: false, align: 'end' },
  { title: 'Total Deduction', key: 'total_deduction', sortable: false, align: 'end' },
  { title: 'Total Payable', key: 'total_payable', sortable: false, align: 'end' },
  { title: 'Approval Status', key: 'approval_status_display', sortable: false, align: 'center', width: '100px' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center', width: '100px' }
]


// Methods
const loadDepartments = async () => {
  departmentsLoading.value = true
  try {
    const response = await store.dispatch('getDepartments')
    departments.value = response.data.data || []
  } catch (error) {
    departments.value = []
    toast.error(error.message || 'Failed to load departments')
  } finally {
    departmentsLoading.value = false
  }
}

const fetchSalaryProcesses = async () => {
  listLoading.value = true
  try {
    // Convert date objects to YYYY-MM-DD format for API
    const processedFilters = { ...filters }
    if (processedFilters.from_date instanceof Date) {
      processedFilters.from_date = processedFilters.from_date.toISOString().split('T')[0]
    }
    if (processedFilters.to_date instanceof Date) {
      processedFilters.to_date = processedFilters.to_date.toISOString().split('T')[0]
    }
    
    const sanitizedFilters = Object.fromEntries(
      Object.entries(processedFilters).filter(([, value]) => value !== null && value !== '')
    )
    const response = await store.dispatch('salaryProcess/getSalaryProcessList', sanitizedFilters)

    if (response.success) {
      console.log('=== BACKEND RESPONSE ===')
      console.log('Full Response:', JSON.stringify(response, null, 2))
      console.log('Salary Processes Data:', response.data)
      
      if (response.data && response.data.length > 0) {
        console.log('=== FIRST ITEM DETAILS ===')
        const firstItem = response.data[0]
        console.log('First Item:', JSON.stringify(firstItem, null, 2))
        console.log('All Fields:', Object.keys(firstItem))
        
        // Show financial fields specifically
        console.log('=== FINANCIAL FIELDS ===')
        console.log('total_gross_salary:', firstItem.total_gross_salary, 'Type:', typeof firstItem.total_gross_salary)
        console.log('total_net_salary:', firstItem.total_net_salary, 'Type:', typeof firstItem.total_net_salary)
        console.log('total_allowance:', firstItem.total_allowance, 'Type:', typeof firstItem.total_allowance)
        console.log('total_deduction:', firstItem.total_deduction, 'Type:', typeof firstItem.total_deduction)
        console.log('total_payable:', firstItem.total_payable, 'Type:', typeof firstItem.total_payable)
        
        // Show all items financial fields
        console.log('=== ALL ITEMS FINANCIAL FIELDS ===')
        response.data.forEach((item, index) => {
          console.log(`Item ${index + 1} (${item.code}):`, {
            total_gross_salary: item.total_gross_salary,
            total_net_salary: item.total_net_salary,
            total_allowance: item.total_allowance,
            total_deduction: item.total_deduction,
            total_payable: item.total_payable
          })
        })
      }
      
      salaryProcesses.value = response.data || []
    } else {
      salaryProcesses.value = []
      toast.error(response.message || 'Failed to load salary process list')
    }
  } catch (error) {
    salaryProcesses.value = []
    const errorMessage = error.response?.data?.message || error.message || 'Failed to load salary process list'
    toast.error(errorMessage)
  } finally {
    listLoading.value = false
  }
}

const handleFilterSubmit = () => {
  fetchSalaryProcesses()
}

const resetFilters = () => {
  filters.process_scope = null
  filters.year = null
  filters.month = null
  filters.department_id = null
  filters.from_date = null
  filters.to_date = null
  fetchSalaryProcesses()
}

const formatDate = (dateString) => {
  if (!dateString) return '—'
  return formatDateView(dateString) || '—'
}

const formatCurrency = (value) => {
  // Show exactly what backend sends, or format if it's a number
  if (value === null || value === undefined) return '—'
  if (typeof value === 'string') {
    // Backend sends as string like "0.00", show as is
    return value
  }
  // If it's a number, format with commas and 2 decimal places
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(value))
}

const formatScopeLabel = (scope) => {
  switch (scope) {
    case 'department':
      return 'Department'
    case 'employee':
      return 'Employee'
    default:
      return 'All'
  }
}

const getScopeColor = (scope) => {
  switch (scope) {
    case 'department':
      return 'deep-purple-lighten-2'
    case 'employee':
      return 'teal-lighten-2'
    default:
      return 'blue-grey-lighten-2'
  }
}

const formatStatusLabel = (status) => {
  if (!status) return '—'
  return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ')
}

const getStatusColor = (status) => {
  if (!status) return 'grey'
  switch (status.toLowerCase()) {
    case 'pending':
      return 'orange'
    case 'approved':
    case 'completed':
      return 'success'
    case 'rejected':
    case 'cancelled':
      return 'error'
    case 'processing':
      return 'info'
    default:
      return 'grey'
  }
}


const viewDetails = (id) => {
  if (!id) {
    toast.error('Process ID is missing')
    return
  }
  console.log('Navigating to details page with ID:', id)
  router.push({ 
    name: 'salary-process-details', 
    params: { id: id } 
  })
}

const hasActiveFilters = computed(() => {
  return Object.values(filters).some((value) => value !== null && value !== '')
})

// Export functions
const formatNumberForExport = (value) => {
  if (!value && value !== 0) return '—'
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
}

const exportToPDF = () => {
  let serialNumber = 1
  const columns = [
    '#SL',
    'Code',
    'Process Scope',
    'Department',
    'Employee',
    'Process Date',
    'Finalize Date',
    'Status',
    'Gross Salary',
    'Net Salary',
    'Total Allowance',
    'Total Deduction',
    'Total Payable'
  ]
  const rows = salaryProcesses.value.map((item) => [
    serialNumber++,
    item.code,
    formatScopeLabel(item.process_scope),
    item.department?.name || '—',
    item.employee?.name || '—',
    formatDate(item.process_date),
    formatDate(item.finalize_date),
    formatStatusLabel(item.salary_status),
    formatNumberForExport(item.total_gross_salary),
    formatNumberForExport(item.total_net_salary),
    formatNumberForExport(item.total_allowance),
    formatNumberForExport(item.total_deduction),
    formatNumberForExport(item.total_payable)
  ])
  
  instance.proxy.$exportTableToPDF(
    columns,
    rows,
    'Salary Process List',
    'salary_process_list_' + instance.proxy.$fileDate()
  )
}

const exportToExcel = () => {
  const data = [[
    '#SL',
    'Code',
    'Process Scope',
    'Department',
    'Employee',
    'Process Date',
    'Finalize Date',
    'Status',
    'Gross Salary',
    'Net Salary',
    'Total Allowance',
    'Total Deduction',
    'Total Payable'
  ]]
  let serialNumber = 1
  
  salaryProcesses.value.forEach((item) => {
    data.push([
      serialNumber++,
      item.code,
      formatScopeLabel(item.process_scope),
      item.department?.name || '—',
      item.employee?.name || '—',
      formatDate(item.process_date),
      formatDate(item.finalize_date),
      formatStatusLabel(item.salary_status),
      formatNumberForExport(item.total_gross_salary),
      formatNumberForExport(item.total_net_salary),
      formatNumberForExport(item.total_allowance),
      formatNumberForExport(item.total_deduction),
      formatNumberForExport(item.total_payable)
    ])
  })
  
  instance.proxy.$exportTableToExcel(data, 'salary_process_list_' + instance.proxy.$fileDate())
}

const exportToCSV = () => {
  const data = [[
    '#SL',
    'Code',
    'Process Scope',
    'Department',
    'Employee',
    'Process Date',
    'Finalize Date',
    'Status',
    'Gross Salary',
    'Net Salary',
    'Total Allowance',
    'Total Deduction',
    'Total Payable'
  ]]
  let serialNumber = 1
  
  salaryProcesses.value.forEach((item) => {
    data.push([
      serialNumber++,
      item.code,
      formatScopeLabel(item.process_scope),
      item.department?.name || '—',
      item.employee?.name || '—',
      formatDate(item.process_date),
      formatDate(item.finalize_date),
      formatStatusLabel(item.salary_status),
      formatNumberForExport(item.total_gross_salary),
      formatNumberForExport(item.total_net_salary),
      formatNumberForExport(item.total_allowance),
      formatNumberForExport(item.total_deduction),
      formatNumberForExport(item.total_payable)
    ])
  })
  
  instance.proxy.$exportTableToCSV(data, 'salary_process_list_' + instance.proxy.$fileDate())
}

// Lifecycle
onMounted(() => {
  loadDepartments()
  fetchSalaryProcesses()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

